import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined';
import PolicyOutlinedIcon from '@mui/icons-material/PolicyOutlined';
import StickyNote2OutlinedIcon from '@mui/icons-material/StickyNote2Outlined';
import LoginOutlinedIcon from '@mui/icons-material/LoginOutlined';
import CampaignOutlinedIcon from '@mui/icons-material/CampaignOutlined';
import { Link } from 'react-router-dom';

const More = () => {
    const { t } = useLanguage();
    return (
        <div className='sidebar-menu'>
            <div className='sidebar-menu-item'>
                <Link to='/about'><InfoOutlineIcon />{t('footer_about')}</Link>
            </div>
            {/* <div className='sidebar-menu-item'>
                <Link to='/contact'><AccountCircleOutlinedIcon />{t('Contact')}</Link>
            </div> */}
            <div className='sidebar-menu-item'>
                <Link to='/awareness'><CampaignOutlinedIcon /> {t('aw_title')} </Link>
            </div>
            <div className='sidebar-menu-item'>
                <Link to='/privacy'><PolicyOutlinedIcon />{t('privacy_title')}</Link>
            </div>
            <div className='sidebar-menu-item'>
                <Link to='/terms'><StickyNote2OutlinedIcon />{t('terms_title')}</Link>
            </div>
            {/* <div className='sidebar-menu-item'>
                <Link to='#'><LoginOutlinedIcon />{t('Logout')}</Link>
            </div> */}
        </div>
    );
};

export default More;